import React from 'react'

import { useElementSize, useTimeout } from '@mantine/hooks'

export const useDebouncedElementSize = (
  debounceIntervalMillis: number = 250,
) => {
  const [height, setHeight] = React.useState(0)
  const [width, setWidth] = React.useState(0)
  const { ref, ...unbounced } = useElementSize()

  const lastUpdateMillis = React.useRef(0)

  const updateState = () => {
    setHeight(unbounced.height)
    setWidth(unbounced.width)
    lastUpdateMillis.current = new Date().valueOf()
  }

  const valueHasChanged =
    height !== unbounced.height || width !== unbounced.width
  const isInitalState = height === 0 && width === 0

  const timeout = useTimeout(updateState, debounceIntervalMillis)

  if (valueHasChanged) {
    // TODO: Move timing, dimension updates, and timer cleanup into an effect.
    // Preserve the first measurement and update interval in a follow-up.
    // oxlint-disable-next-line react/refs, react/purity
    const timeSinceLastUpdate = new Date().valueOf() - lastUpdateMillis.current
    const isLongEnough = timeSinceLastUpdate > debounceIntervalMillis
    if (isInitalState || isLongEnough) {
      // oxlint-disable-next-line react/refs
      updateState()
    } else {
      timeout.start()
    }
  }

  return {
    ref,
    height,
    width,
  }
}
